import { CheckBox } from "@dealer-center/core-components";
import { useEffect, useState } from "react";
import styled from "styled-components";
import type { GroupsPayload } from "@dealer-center/ddc-pages-incentives-manager-lambda";
import type { IncentivesRecord } from "@dealer-center/ddc-pages-incentives-manager-interface";
import { Locale } from "@dealer-center/ddc-core-utils";
import type { EditIncentivesDisableFlags } from "@dealer-center/ddc-pages-incentives-manager-interface";

const StyledPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0;
  height: 100%;
  box-sizing: border-box;

  .ids-checkbox-container {
    align-items: flex-start;
  }
`;

const StyledH4 = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: normal;
  font-family: "Roboto Flex", Roboto, sans-serif;
`;

export const IncentivesDistributionListsPanel = ({
  disableFlags,
  groups,
  incentive,
  onFlagChange
}: {
  disableFlags: EditIncentivesDisableFlags;
  groups: GroupsPayload;
  incentive: IncentivesRecord;
  onFlagChange: (groupIndex: number, isChecked: boolean) => void;
}) => {
  const [isActive, setIsActive] = useState<boolean[]>([]);

  useEffect(() => {
    if (groups) {
      setIsActive(
        groups.map(item => {
          return (
            incentive.accountMap?.distributionListIdList?.includes(
              item.id || ""
            ) || false
          );
        })
      );
    }
  }, [groups, incentive]);

  if (disableFlags.hideDistributionLists) {
    return null;
  }
  return (
    <>
      <StyledH4>{Locale.getText("SELECT_DISTRIBUTION_LISTS")}</StyledH4>
      <StyledPanel>
        {groups?.map((group, idx) => (
          <CheckBox
            checked={isActive[idx]}
            disabled={disableFlags.disableDistributionLists}
            id={group.id}
            key={group.id}
            label={group.name || ""}
            value={idx.toString()}
            onChange={e => {
              if (e.target.label && e.target.value.checked !== undefined) {
                onFlagChange(
                  parseInt(e.target.value.checkboxValue, 10),
                  e.target.value.checked
                );
              }
            }}
          />
        ))}
      </StyledPanel>
    </>
  );
};
